import React from 'react';
import ModalLayout from '@components/Modal/ModalLayout';
import GenericUpdateModal from '@components/Modal/GenericUpdateModal';

const UserDetailsUpdateModal = ({
  title,
  isOpen,
  onClose,
  initialValue,
  fieldName,
  isLoading,
  onSubmit
}) => {
  return (
    <ModalLayout isOpen={isOpen} onClose={onClose}>
      <GenericUpdateModal
        title={title}
        data={{ [fieldName]: initialValue }}
        isLoading={isLoading}
        onCancel={onClose}
        onSubmit={(values) => {
          onSubmit({
            fieldName,
            fieldValue: values[fieldName]
          });
        }}
      />
    </ModalLayout>
  );
};

export default UserDetailsUpdateModal;